<template>
  <section class='error-page'>
    <app-header v-if='authenticated'></app-header>
    <section class='content'>
      <slot></slot>
    </section>
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  import appHeader from '@/pages/authenticated/app-header'

  export default {
    name: 'error-page',
    components: {
      'app-header': appHeader
    },

    computed: {
      ...mapState('user', {
        authenticated: ({ authenticated }) => authenticated
      }),

      ...mapState('error', {
        error: ({ response }) => response
      })
    },

    created () {
      if (!this.error) {
        this.$router.push({
          path: '/'
        })
      }
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .error-page {
    h1 {
      font-size: 16rem;
      color: $color-daddy;
      margin-bottom: $space-small;
      font-weight: 600;
    }

    h2 {
      font-size: 3rem;
      font-weight: 300;
      margin-bottom: $space-small;
    }

    p {
      color: $color-daddy;
      margin-bottom: $space-big;
    }
  }
</style>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .app-header + .content {
    padding-top: $header-height;
  }

  .content {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
